// import React from "react";
// import { useState, useEffect } from "react";
// import axios from "axios";
// import Resources, { resources } from "../Resourses/Resources";
// import Cookies from "js-cookie";
// import { ContactMail } from "@mui/icons-material";

// const StudentEnquiryForm = () => {
//   const [departMent, setDepartment] = useState("");
//   const [rollNumber, setRollNumber] = useState("");
//   const useData = Cookies.get("userDetails");
//   const userDetails = JSON.parse(useData);
//   const [enquiryData, setEnquiryData] = useState({
//     rollNumber: "",
//     name: "",
//     subject: "",
//     mail: "",
//     contact: "",
//     message: "",
//     departMent: "",
//     status: "Pending",
//   });
//   useEffect(() => {
//     const roll = userDetails.username;
//     const branchdata = userDetails.program;
//     setRollNumber(userDetails.username);
//     setDepartment(userDetails.program);
//     setEnquiryData({
//       ...enquiryData,
//       rollNumber: roll,
//       departMent: branchdata,
//     });
//   }, []);
//   const handleSaveDataEnquiryData = async () => {
//     if (
//       !enquiryData.name ||
//       !enquiryData.departMent ||
//       !enquiryData.mail ||
//       !enquiryData.contact ||
//       !enquiryData.message
//     ) {
//       alert("All fields are required!");
//       return;
//     }
//     try {
//       const res = await axios.post(
//         resources.APPLICATION_URL + "enquiryForm/save",
//         enquiryData
//       );
//       if (res.data) {
//         alert("Enquiry Added Successfully");
//         setEnquiryData({
//           name: "",
//           departMent:"",
//           subject: "",
//           mail: "",
//           contact: "",
//           message: "",

//         });
//       }
//     } catch (e) {
//       console.log(e);
//     }
//   };

//   return (
//     <div className="enQuiryFormConatainer">
//       <h3 className="headersTag">ENQUIRY FORM</h3>

//       <div className="enquirySubdiv">
//         <div className="enquirySubdivOne">
//           <div className="enQuiryInputDiv">
//             <label htmlFor="Name">Role</label>
//             <input
//               value={enquiryData.rollNumber}
//               onChange={(e) =>
//                 setEnquiryData({ ...enquiryData, rollNumber: e.target.value })
//               }
//               type="text"
//               disabled="true"
//               id="Name"
//               name="name"
//               required
//             />
//           </div>
//           <div className="enQuiryInputDiv">
//             <label htmlFor="Name">Name</label>
//             <input
//               value={enquiryData.name}
//               onChange={(e) =>
//                 setEnquiryData({ ...enquiryData, name: e.target.value })
//               }
//               type="text"
//               placeholder="Enter Name"
//               id="Name"
//               name="name"
//               required
//             />
//           </div>
//           <div className="enQuiryInputDiv">
//             <label htmlFor="Department"></label>
//             <input
//               value={enquiryData.departMent}
//               onChange={(e) =>
//                 setEnquiryData({ ...enquiryData, departMent: e.target.value })
//               }
//               type="text"
//               placeholder="Department"
//               id="DepartMent"
//               name="departMent"
//               required
//             />
//           </div>
//           <div className="enQuiryInputDiv">
//             <label htmlFor="Email">Email</label>
//             <input
//               value={enquiryData.mail}
//               onChange={(e) =>
//                 setEnquiryData({ ...enquiryData, mail: e.target.value })
//               }
//               type="email"
//               placeholder="Email"
//               id="Email"
//               name="mail"
//               required
//             />
//           </div>
//           <div className="enQuiryInputDiv">
//             <label htmlFor="Contact">Contact</label>
//             <input
//               value={enquiryData.contact}
//               onChange={(e) => {
//                 const value = e.target.value
//                   .replace(/[^0-9]/g, "")
//                   .slice(0, 10); // Remove non-numeric characters, limit to 10 digits
//                 setEnquiryData({ ...enquiryData, contact: value });
//               }}
//               type="text" // We are using text to better control the input
//               placeholder="Contact"
//               id="Contact"
//               name="contact"
//               required
//             />
//           </div>
//         </div>
//         <div className="enquirySubdivTwo">
//           <label htmlFor="Message">Message</label>
//           <textarea
//             value={enquiryData.message}
//             onChange={(e) =>
//               setEnquiryData({ ...enquiryData, message: e.target.value })
//             }
//             name="message"
//             type="text"
//             cols={30}
//             rows={5}
//             placeholder="Message"
//             id="Message"
//             required
//           />
//         </div>
//       </div>
//       <div className="enquiryButtonDiv">
//         <button
//           className=""
//           type="button"
//           onClick={() => handleSaveDataEnquiryData()}
         
//         >
//           Submit
//         </button>
//       </div>
//     </div>
//   );
// };

import React, { useState } from "react";
import axios from "axios";
import Resources, { resources } from "../Resourses/Resources";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const successMessage = (message) => {
  toast.success(message, {
    position: "top-center", 
    toastId: "success1",
    // className: "success",
  });
};

const errorMessage = (message) => {
  toast.error(message, {
    position: "top-center", 
    // className: "error",
  });
};

const StudentEnquiryForm = () => {
  const [loading,setLoading] = useState(false)
  const [enquiryData, setEnquiryData] = useState({
    rollNumber: "",
    name: "",
    subject: "",
    mail: "",
    contact: "",
    message: "",
    departMent: "",
    status: "Pending",
  });

  const handleSaveDataEnquiryData = async () => {
    setLoading(true)
    try {
      if (
        !enquiryData.rollNumber ||
        !enquiryData.name ||
        !enquiryData.departMent ||
        !enquiryData.mail ||
        !enquiryData.contact ||
        !enquiryData.message
      ) {
        errorMessage("All fields are required!");
        return;
      }
      const res = await axios.post(
        resources.APPLICATION_URL + "enquiryForm/save",
        enquiryData
      );
      if (res.data) {
        // successMessage("Thank you! We will contact you soon. For any inquiries, please call 0000000000.");
        successMessage("Thank you! We will contact you soon.")
        setEnquiryData({
          rollNumber: "",
          name: "",
          subject: "",
          mail: "",
          contact: "",
          message: "",
          departMent: "",
          status: "Pending",
        });
      }
    } catch (e) {
      console.log("Save error:", e);
    } finally{
      setLoading(false)
    }
  };

  return (
    <div className="enQuiryFormConatainer">
      <h3 className="headersTag">ENQUIRY FORM</h3>

      <div className="enquirySubdiv">
        <div className="enquirySubdivOne">

          <div className="enQuiryInputDiv">
            <label htmlFor="Roll">Role</label>
            <input
              value={enquiryData.rollNumber}
              onChange={(e) =>
                setEnquiryData({ ...enquiryData, rollNumber: e.target.value })
              }
              type="text"
              placeholder="Enter Role"
              id="Roll"
              name="rollNumber"
              required
            />
          </div>

          <div className="enQuiryInputDiv">
            <label htmlFor="Name">Name</label>
            <input
              value={enquiryData.name}
              onChange={(e) =>
                setEnquiryData({ ...enquiryData, name: e.target.value })
              }
              type="text"
              placeholder="Enter Name"
              id="Name"
              name="name"
              required
            />
          </div>

          <div className="enQuiryInputDiv">
            <label htmlFor="DepartMent">Department</label>
            <input
              value={enquiryData.departMent}
              onChange={(e) =>
                setEnquiryData({ ...enquiryData, departMent: e.target.value })
              }
              type="text"
              placeholder="Enter Department"
              id="DepartMent"
              name="departMent"
              required
            />
          </div>

          <div className="enQuiryInputDiv">
            <label htmlFor="Email">Email</label>
            <input
              value={enquiryData.mail}
              onChange={(e) =>
                setEnquiryData({ ...enquiryData, mail: e.target.value })
              }
              type="email"
              placeholder="Enter Email"
              id="Email"
              name="mail"
              required
            />
          </div>

          <div className="enQuiryInputDiv">
            <label htmlFor="Contact">Contact</label>
            <input
              value={enquiryData.contact}
              onChange={(e) => {
                const value = e.target.value.replace(/[^0-9]/g, "").slice(0, 10);
                setEnquiryData({ ...enquiryData, contact: value });
              }}
              type="text"
              placeholder="Enter Contact Number"
              id="Contact"
              name="contact"
              required
            />
          </div>
        </div>

        <div className="enquirySubdivTwo">
          <label htmlFor="Message">Message</label>
          <textarea
            value={enquiryData.message}
            onChange={(e) =>
              setEnquiryData({ ...enquiryData, message: e.target.value })
            }
            name="message"
            cols={30}
            rows={5}
            placeholder="Enter Message"
            id="Message"
            required
          />
        </div>
      </div>

      <div className="enquiryButtonDiv">
        <button type="button" onClick={handleSaveDataEnquiryData} disabled={loading}>
          {loading ? "Loading..." : "Submit"}
        </button>
      </div>
    </div>
  );
};

export default StudentEnquiryForm;

